import { privateApi } from "./api.interceptor";

class MenuService {
  getAll = () => privateApi.get('/menus');
  delete = (id) => privateApi.delete(`/menus/${id}`);
  switchStatus = (data) => {
    if(data['available']){
      return privateApi.patch(`/menus/disable_menu/${data['id']}`);
    }
    return privateApi.patch(`/menus/enable_menu/${data['id']}`);
  }
  create = (data) => privateApi.post("/menus", data, {
    headers: {'content-type': 'multipart/form-data'}
  });
  update = (data) => privateApi.put(`/menus/${data.get('id')}`, data, {
    headers: {'content-type': 'multipart/form-data'}
  });

}

export default new MenuService();